/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import Parallax from 'rc-scroll-anim/lib/ScrollParallax';
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import { injectIntl } from 'react-intl';
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const { TweenOneGroup } = TweenOne;

const featuresEN = [
  {
    title: 'Increase Collaboration',
    content: 'Employee involvement is one of the greatest contributors to change success',
    src: 'collaboration.png',
    color: '#13C2C2',
    shadowColor: 'rgba(19,194,194,.12)',
  },
  {
    title: 'Centralise Change Management',
    content: 'No more storing change documents in a drawer under your desk',
    src: 'centralise.png',
    color: '#2F54EB',
    shadowColor: 'rgba(47,84,235,.12)',
  },
  {
    title: 'Leverage Data',
    content: 'Interactive reporting on change initiatives enables increased business value',
    src: 'leverage.png',
    color: '#EB2F96',
    shadowColor: 'rgba(235,45,150,.12)',
  },
  {
    title: 'Embrace Best Practice',
    content:
      "Built on best practice change principals, Sortd ensures you're doing the right thing at each step",
    src: 'embrace.png',
    color: '#FA8C16',
    shadowColor: 'rgba(250,140,22,.12)',
  },
  {
    title: 'Control Documentation',
    content: 'Ensure everyone in your organisation is using the same change tools',
    src: 'control.png',
    color: '#F5222D',
    shadowColor: 'rgba(245,34,45,.12)',
  },
  {
    title: 'Save Time',
    content: 'Spend less time planning and more time changing',
    src:
      'time.png',
    color: '#722ED1',
    shadowColor: 'rgba(114,46,209,.12)',
  },
  
];

const pointPos = [
  { x: -30, y: -10 },
  { x: 20, y: -20 },
  { x: -65, y: 15 },
  { x: -45, y: 80 },
  { x: 35, y: 5 },
  { x: 50, y: 50, opacity: 0.2 },
];

function renderImage(file) {
  return (
    <Img fixed={file.node.childImageSharp.fixed} />
  )
}

class Page1 extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hoverNum: null,
    };
  }

  onMouseOver = (i) => {
    this.setState({
      hoverNum: i,
    });
  };

  onMouseOut = () => {
    this.setState({
      hoverNum: null,
    });
  };

  getEnter = (e) => {
    const i = e.index;
    const r = Math.random() * 2 - 1;
    const y = Math.random() * 10 + 5;
    const delay = Math.round(Math.random() * (i * 50));
    return [
      {
        delay,
        opacity: 0.4,
        ...pointPos[e.index],
        ease: 'easeOutBack',
        duration: 300,
      },
      {
        y: r > 0 ? `+=${y}` : `-=${y}`,
        duration: Math.random() * 1000 + 2000,
        yoyo: true,
        repeat: -1,
      },
    ];
  };



  render() {
    const { hoverNum } = this.state;
    const { isMobile } = this.props;
    let children = [[], [], []];
    featuresEN.forEach((item, i) => {
      const isHover = hoverNum === i;
      const pointChild = [
        'point-0 left',
        'point-0 right',
        'point-ring',
        'point-1',
        'point-2',
        'point-3',
      ].map((className) => (
        <TweenOne
          component="i"
          className={className}
          key={className}
          style={{
            background: item.color,
            borderColor: item.color,
          }}
        />
      ));
      const child = (
        <li key={i.toString()}>
          <div
            className="page1-box"
            onMouseEnter={() => {
              this.onMouseOver(i);
            }}
            onMouseLeave={this.onMouseOut}
          >
            <TweenOneGroup
              className="page1-point-wrapper"
              enter={this.getEnter}
              leave={{
                x: 0,
                y: 30,
                opacity: 0,
                duration: 300,
                ease: 'easeInBack',
              }}
              resetStyle={false}
              exclusive
            >
              {(isMobile || isHover) && pointChild}
            </TweenOneGroup>
            <div
              className="page1-image"
              style={{
                boxShadow: `${isHover ? '0 12px 24px' : '0 6px 12px'} ${item.shadowColor}`,
              }}
            >
            <StaticQuery
            variables={item.src}
            query={graphql`
            query {
              images: allFile(filter: { sourceInstanceName: { eq: "images" } }) {
                edges {
                  node {
                    extension
                    relativePath
                    childImageSharp {
                    fixed(width: 25, height: 25) {
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
          }
              `}
            render={data => {
              const image = data.images.edges.find(
                im => im.node.relativePath === item.src
              )
              return(renderImage(image))
            }} />
            </div>
            <h3>{item.title}</h3>
            <p>{item.content}</p>
          </div>
        </li>
      );
      children[Math.floor(i / 3)].push(child);
    });

    children = children.map((item, i) => (
      <QueueAnim
        className="page1-box-wrapper"
        key={i.toString()}
        type="bottom"
        leaveReverse
        delay={[i * 100, (children.length - 1 - i) * 100]}
        component="ul"
      >
        {item}
      </QueueAnim>
    ));
    return (
      <div className="home-page page1">
        <div className="home-page-wrapper" id="page1-wrapper">
          {!isMobile && (
            <Parallax
              className="page1-bg"
              animation={{
                translateY: 200,
                ease: 'linear',
                playScale: [0, 1.65],
              }}
              location="page1-wrapper"
            >
              Benefits
            </Parallax>
          )}
          <h2>
            What <span>Sortd</span> can do for you{' '}
          </h2>
          <div className="title-line-wrapper page1-line">
            <div className="title-line" />
          </div>
          <OverPack>{children}</OverPack>
        </div>
      </div>
    );
  }
}

export default injectIntl(Page1);
